import * as yup from 'yup';

export const otpSchema = yup.string().length(4).required();
